import { useLocation } from 'react-router-dom';
import { isMinimalChromePath } from '../utils/chromeRoutes';

/**
 * Store chrome switch. Renders `children` (header, footer, bottom nav,
 * floating buttons, pop-ups) on normal routes and `minimal` (default nothing)
 * on the enclosed checkout routes (utils/chromeRoutes).
 */
const ChromeGate = ({ children, minimal = null }) => {
  const { pathname } = useLocation();
  return isMinimalChromePath(pathname) ? minimal : children;
};

export default ChromeGate;
